const quotes = [
  {
    quote: "The most beautiful thing we can experience is the mysterious. It is the source of all true art and science",
    attribution: "Albert Einstein"
  },
  {
    quote: "Science knows no country, because knowledge belongs to humanity, and is the torch which illuminates the world",
    attribution: "Louis Pasteur"
  },
  {
    quote: "Sometimes it is the people no one can imagine anything of who do the things no one can imagine",
    attribution: "Alan Turing"
  },
  {
    quote: "Science can amuse and fascinate us all, but it is engineering that changes the world",
    attribution: "Isaac Asimov"
  },
  {
    quote: "If debugging is the process of removing software bugs, then programming must be the process of putting them in",
    attribution: "Edsger Dijkstra"
  },
  {
    quote: "The only way to learn a new programming language is by writing programs in it",
    attribution: "Dennis Ritchie"
  },
  {
    quote: "Hands-on experience is the best way to learn about all the interdisciplinary aspects of robotics",
    attribution: "Rodney Brooks"
  },
  {
    quote: "We can only see a short distance ahead, but we can see plenty there that needs to be done",
    attribution: "Alan Turing"
  },
  {
    quote: "Robotics is not just a field of science; it's a canvas for art, innovation, and progress",
    attribution: "Rodney Brooks"
  },
  {
    quote: "I was always very interested in science, and I knew that for me, science was a better long-term career than tennis",
    attribution: "Sally Ride"
  }
];

export default quotes;